import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAeFzbsVDeUt9V1frGBucp7FgX1d_cgvKk",
  authDomain: "apex-pips.firebaseapp.com",
  projectId: "apex-pips",
  storageBucket: "apex-pips.firebasestorage.app",
  messagingSenderId: "196473100924",
  appId: "1:196473100924:web:9bba43113a76835ea187f9",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
